import MobileNavigation from 'apps/application/navigation/mobile-navigation';
import DesktopKeyboardNavigation from 'apps/application/navigation/desktop-keyboard-navigation';

export const HEADER_OVERLAY_CLASS = 'header__overlay';
export const HEADER_OVERLAY_VISIBLE_CLASS = 'header__overlay--visible';
export const HEADER_OVERLAY_FULL_HEIGHT_CLASS = 'header__overlay--full-height';

let headerOverlay;
let isOpen;

export const getState = function() {
  return isOpen;
};

const getHeaderOverlay = function() {
  return (
    headerOverlay || document.getElementsByClassName(HEADER_OVERLAY_CLASS)[0]
  );
};

export const showHeaderOverlay = function({ isFullHeight } = {}) {
  const classes = [HEADER_OVERLAY_VISIBLE_CLASS];
  if (isFullHeight) {
    classes.push(HEADER_OVERLAY_FULL_HEIGHT_CLASS);
  }
  const overlay = getHeaderOverlay();
  overlay && overlay.classList.add(...classes);
};

export const hideHeaderOverlay = function() {
  const overlay = getHeaderOverlay();

  overlay &&
    overlay.classList.remove(
      HEADER_OVERLAY_VISIBLE_CLASS,
      HEADER_OVERLAY_FULL_HEIGHT_CLASS
    );
};

export const toggleVisibility = function() {
  isOpen = !isOpen;
};

export const attachListeners = ({ hideHeaderOverlay, showHeaderOverlay }) => {
  new MobileNavigation(document.querySelector('[data-js="mobile-navigation"]'));

  new DesktopKeyboardNavigation(
    document.querySelector('[data-js="desktop-navigation"]'),
    showHeaderOverlay,
    hideHeaderOverlay
  );
};

if (typeof document !== 'undefined' && !global.__isHeaderInitialized) {
  global.__isHeaderInitialized = true;

  headerOverlay = document.getElementsByClassName(HEADER_OVERLAY_CLASS)[0];
  isOpen = false;

  const listenerParams = {
    headerOverlay,
    hideHeaderOverlay,
    setTimeout,
    showHeaderOverlay,
    toggleVisibility,
  };

  attachListeners(listenerParams);
}
